import {
  FaArrowRight,
  FaEnvelope,
  FaGavel,
  FaMapMarkerAlt,
  FaRegClock,
  FaShieldAlt,
  FaWhatsapp,
} from "react-icons/fa";

import advocate from "../../assets/advocate-removebg-preview.png";

const highlights = [
  {
    icon: FaShieldAlt,
    title: "Análise cuidadosa",
    text: "Cada demanda recebe leitura individual e orientação objetiva.",
  },
  {
    icon: FaMapMarkerAlt,
    title: "Rio Verde e região",
    text: "Atendimento presencial e online com postura profissional.",
  },
  {
    icon: FaRegClock,
    title: "Resposta ágil",
    text: "Comunicação clara do primeiro contato até a conclusão.",
  },
];

export default function Hero() {
  return (
    <section id="home" className="relative isolate overflow-hidden bg-slate-950 text-white">
      <div className="absolute inset-0 -z-10 bg-[radial-gradient(circle_at_top_left,rgba(202,138,4,0.28),transparent_28%),radial-gradient(circle_at_80%_20%,rgba(255,255,255,0.12),transparent_24%),linear-gradient(180deg,#0f172a_0%,#111827_100%)]" />
      <div className="absolute inset-x-0 top-0 -z-10 h-px bg-gradient-to-r from-transparent via-amber-300/70 to-transparent" />

      <div className="mx-auto grid max-w-7xl gap-14 px-4 py-20 sm:px-6 lg:grid-cols-[1.15fr_0.85fr] lg:items-center lg:px-8 lg:py-28">
        <div className="max-w-3xl">
          <span className="inline-flex items-center gap-2 rounded-full border border-amber-300/20 bg-white/5 px-4 py-2 text-xs font-semibold uppercase tracking-[0.3em] text-amber-200/90">
            <FaGavel className="text-sm" />
            Atendimento jurídico em Rio Verde - GO
          </span>

          <h1 className="mt-6 text-4xl font-semibold leading-tight tracking-tight text-white sm:text-5xl lg:text-7xl">
            Advocacia estratégica com atendimento humano e postura técnica.
          </h1>

          <p className="mt-6 max-w-2xl text-lg leading-8 text-slate-300 sm:text-xl">
            Atuação em Direito do Trabalho, Previdenciário, Consumidor, Civil e
            Compliance, com foco em orientação clara, prevenção de riscos e
            solução eficiente.
          </p>

          <p className="mt-5 max-w-2xl text-base leading-7 text-slate-400">
            Cada caso é tratado com atenção ao detalhe, linguagem acessível e
            acompanhamento próximo do início ao fim.
          </p>

          <div className="mt-10 flex flex-wrap gap-4">
            <a
              href="https://wa.me/message/7PUPDXBNVORFM1"
              className="inline-flex items-center gap-3 rounded-full bg-amber-400 px-6 py-3 text-sm font-semibold text-slate-950 transition hover:-translate-y-0.5 hover:bg-amber-300"
            >
              <FaWhatsapp className="text-base" />
              Falar no WhatsApp
              <FaArrowRight className="text-sm" />
            </a>
            <a
              href="mailto:contato@cleisson.adv.br"
              className="inline-flex items-center gap-3 rounded-full border border-white/15 bg-white/5 px-6 py-3 text-sm font-semibold text-white transition hover:-translate-y-0.5 hover:bg-white/10"
            >
              <FaEnvelope className="text-base text-amber-200" />
              Enviar e-mail
            </a>
          </div>

          <div className="mt-12 grid gap-4 sm:grid-cols-3">
            {highlights.map((item) => {
              const Icon = item.icon;

              return (
                <article
                  key={item.title}
                  className="rounded-[1.5rem] border border-white/10 bg-white/5 p-5 backdrop-blur-md"
                >
                  <Icon className="text-lg text-amber-300" />
                  <h3 className="mt-4 text-lg font-semibold text-white">
                    {item.title}
                  </h3>
                  <p className="mt-2 text-sm leading-6 text-slate-300">
                    {item.text}
                  </p>
                </article>
              );
            })}
          </div>

          <div className="mt-10 flex flex-wrap gap-3 text-sm text-slate-300">
            <span className="rounded-full border border-white/10 bg-white/5 px-4 py-2">
              OAB/GO 63.812
            </span>
            <span className="rounded-full border border-white/10 bg-white/5 px-4 py-2">
              Atendimento presencial e online
            </span>
          </div>
        </div>

        <div className="relative flex items-center justify-center">
          <div className="absolute inset-10 rounded-[2.5rem] bg-amber-400/20 blur-3xl" />
          <div className="relative flex w-full max-w-[560px] justify-center overflow-hidden rounded-[2.25rem] border border-white/10 bg-white/5 p-4 shadow-2xl shadow-black/30 backdrop-blur-xl">
            <div className="absolute inset-0 bg-[linear-gradient(180deg,rgba(255,255,255,0.14),transparent_35%)]" />
            <img
              src={advocate}
              alt="Cleisson Oliveira"
              className="relative z-10 w-full max-w-[460px] -translate-y-10 drop-shadow-[0_28px_80px_rgba(0,0,0,0.45)] sm:-translate-y-14 lg:-translate-y-16"
            />

            <div className="absolute bottom-5 left-1/2 z-20 w-[min(88%,360px)] -translate-x-1/2 rounded-2xl border border-white/10 bg-slate-950/82 px-5 py-4 text-center shadow-lg backdrop-blur">
              <p className="text-[0.65rem] font-semibold uppercase tracking-[0.3em] text-amber-300">
                OAB/GO 63.812
              </p>
              <p className="mt-1 text-sm leading-6 text-slate-200">
                Atendimento particular, preventivo e contencioso.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
